function p(a) {
  try {
    const o = new URL(a);
    if (o.hostname.split(".").length < 2)
      throw null;
    return {
      hasDomain: !0,
      domain: o.port.trim() !== "" ? `${o.hostname}:${o.port}` : o.hostname
    };
  } catch {
    return {
      hasDomain: !1,
      domain: ""
    };
  }
}
function D(a) {
  const o = a.trim().toLowerCase();
  if (o.startsWith("//")) {
    const e = `https:${o}`;
    return {
      hasProtocol: p(e).hasDomain,
      // Even if it contains a valid relative protocol string, we can not count it as valid since it does not contain a valid domain
      protocol: "relative"
      // It contains a valid protocol
    };
  }
  const n = /^(http|https):\/\//.test(o);
  return {
    hasProtocol: n,
    protocol: n ? o.split("://")[0] : "none"
  };
}
function R(a, o) {
  return a.slice(o ? 1 : 0).filter((n) => n.trim() !== "").map((n, e) => e === 0 || n.startsWith(".") || n.includes(":") ? n : `/${n}`).join("");
}
function U(a, o) {
  let n = 0, e = "";
  const t = [];
  for (const r of a) {
    if (r === "" && t.length > 0) {
      t.push(r);
      continue;
    }
    if (n + r.length <= o)
      e += r, n += r.length;
    else if (n < o) {
      const i = o - n;
      e += r.slice(0, i), i < r.length && (t.push(e), e = "", t.push(r.slice(i))), n += i;
    } else
      e !== "" && (t.push(e), e = ""), t.push(r);
  }
  return e !== "" && (t.push(e), e = ""), t;
}
function L(a, o) {
  const n = R(a, o), e = p(`https://${n}`);
  if (!e.hasDomain) return a;
  const t = n.indexOf(e.domain) + e.domain.length, r = a.slice(o ? 1 : 0);
  let i = "", c = 0, f = [];
  for (const u of r) {
    if (u === "") {
      c >= t && (f.length > 0 || (f.push(i), i = ""), f.push(u));
      continue;
    }
    if (c + u.length <= t)
      i += u, c += u.length;
    else if (c < t) {
      const s = t - c;
      i += u.slice(0, s), s < u.length && (f.push(i), i = "", f.push(u.slice(s))), c += s;
    } else
      i !== "" && (f.push(i), i = ""), f.push(u);
  }
  return i !== "" && (f.push(i), i = ""), o && a[0] && (f = [a[0], ...f]), f;
}
function $(a, o) {
  let n = [...a];
  o.allowEmptyPathSegments || (n = n.filter(
    (c) => c.trim() !== ""
  ));
  const e = n.join(""), { hasProtocol: t, protocol: r } = D(
    e
  );
  let i = n;
  if (t) {
    const c = e.indexOf(
      r === "relative" ? "//" : "://"
    ) + (r === "relative" ? 2 : 3);
    i = U(
      n,
      c
    ), i.length > 1 && (i[1] = (i[1] ?? "").replace(/^\/*/, ""));
  }
  return i = L(i, t), {
    array: i,
    hasProtocol: t,
    protocol: r
  };
}
function P(a) {
  const { array: o, hasProtocol: n } = a;
  if (n) {
    const e = o.length > 1 ? o.slice(1) : [];
    return `${o.length > 0 ? o[0] : ""}${e.join("/")}`;
  }
  return o.join("/");
}
const w = {
  forceProtocol: "auto",
  trailingSlash: "remove",
  strict: !1,
  allowEmptyPathSegments: !1,
  arraySerializer: "repeat"
}, d = {
  params: {},
  hash: "",
  config: w
};
let y = {
  ...d.config
};
function v() {
  return y;
}
function F(a) {
  y = {
    ...d.config,
    ...a
  };
}
function E(...a) {
  if (a.length === 0 || a.length > 0 && typeof a[0] != "string")
    throw new Error("makeURL must receive at least one string item");
  let o = { config: {} };
  const n = [];
  a.forEach((s, h) => {
    if (typeof s == "string")
      n.push(s);
    else {
      if (h !== a.length - 1)
        throw new Error(
          "Params config object argument must be the last argument"
        );
      o = s;
    }
  });
  const e = {
    ...d,
    ...o,
    config: {
      ...y,
      ...o == null ? void 0 : o.config
    }
  }, t = $(
    n,
    e.config
  );
  if (t.array = t.array.map(
    (s, h) => h === 0 && t.hasProtocol ? s : s.split("/").map((l) => encodeURIComponent(l).replace(/%3A/g, ":")).join("/")
  ), !t.hasProtocol && e.config.forceProtocol !== "none")
    if (e.config.forceProtocol === "auto" || e.config.forceProtocol === "auto-insecure") {
      const s = e.config.forceProtocol === "auto";
      p(
        `https://${P(t)}`
      ).hasDomain && (t.array = [
        `${s ? "https" : "http"}://`,
        ...t.array
      ], t.hasProtocol = !0, t.protocol = s ? "https" : "http");
    } else
      t.array = [
        `${e.config.forceProtocol}://`,
        ...t.array
      ], t.hasProtocol = !0, t.protocol = e.config.forceProtocol;
  let r = P(t);
  if (e.config.trailingSlash === "add" && !r.endsWith("/") && (r += "/"), e.config.trailingSlash === "remove" && r.endsWith("/") && (r = r.slice(0, -1)), !e.config.allowEmptyPathSegments) {
    let s = "";
    t.protocol === "relative" && (t.hasProtocol ? s = "//" : s = "/", r = r.slice(2)), r = `${s}${r.replace(new RegExp("(?<!:)\\/{2,}", "g"), "/")}`;
  }
  const i = {};
  for (const s of Object.entries(e.params)) {
    const [h, l] = s;
    let g = "", m = !1;
    typeof l == "string" ? g = l : typeof l == "number" ? g = l.toString() : Array.isArray(l) ? (m = !0, e.config.arraySerializer === "stringify" ? g = JSON.stringify(l) : e.config.arraySerializer === "repeat" ? g = l : g = l.join(",")) : typeof l == "object" ? g = JSON.stringify(l) : g = `${l}`, i[h] = {
      value: g,
      isArray: m
    };
  }
  const c = new URLSearchParams();
  for (const s of Object.entries(i)) {
    const [h, l] = s;
    if (l.isArray) {
      if (Array.isArray(l.value))
        for (const S of l.value)
          c.append(h, S);
      else
        c.append(h, l.value);
      continue;
    }
    let g = !1;
    const m = new RegExp(`:${h}`, "g"), A = encodeURIComponent(l.value);
    r = r.replace(m, () => (g = !0, A)), g ? delete i[h] : c.append(h, l.value);
  }
  const f = c.toString();
  f && (r += `?${f}`);
  const u = e.hash.trim();
  if (u !== "" && (r += `#${encodeURIComponent(u)}`), e.config.strict)
    try {
      if (!p(r).hasDomain)
        throw null;
    } catch {
      throw new Error(`The generated URL is not valid: ${r}`);
    }
  return r;
}
export {
  w as BASE_DEFAULT_MAKE_URL_CONFIG,
  v as getMakeURLDefaultConfig,
  E as makeURL,
  F as setMakeURLDefaultConfig
};
//# sourceMappingURL=make-url.js.map
